import(/* webpackMode: "eager" */ "/Users/kuwatataiga/Downloads/resume_truemee_backup/frontend/app/landing/page.tsx");
